import { render, staticRenderFns } from "./ModificarEmpresa.vue?vue&type=template&id=207e8ac4&scoped=true"
import script from "./ModificarEmpresa.vue?vue&type=script&lang=js"
export * from "./ModificarEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207e8ac4",
  null
  
)

export default component.exports